import { BillingCycles } from "../types";

const prepayPlan = (purchase: any) => ({
    billingCycle: purchase?.product?.durationInMonths === 24 ? BillingCycles.BIENNIAL : BillingCycles.QUARTERLY,
    productId: purchase?.product?.id,
  });
export default prepayPlan;